namespace TabAurous.ECommerce {
    export namespace OrderMagentoImportService {
        export const baseUrl = 'ECommerce/OrderMagentoImport';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ECommOrderRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "ECommerce/OrderMagentoImport/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>OrderMagentoImportService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
